export default function ReminderOutdoorFireplaces() {
  return (
    <div className="accordion-item">
      <h2 className="accordion-header">
        <button className="accordion-button caret-off collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseReminderOutdoorFireplaces">
          
           <i className="fa-solid fa-fire-burner fa-2xl feature-icon af-icon"></i>
                <b>REMINDER from the Fire Marshal&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<br/>Outdoor Fireplaces</b>
                <span className="badge text-bg-warning">SAFETY</span>
        </button>
      </h2>
      <div id="collapseReminderOutdoorFireplaces" className="accordion-collapse collapse" data-bs-parent="#latestNewsAccordion">
        <div className="accordion-body">
          
            <ul>
            <li>Morrisville Borough's Fire Prevention Code allows for the use of portable outdoor fireplaces, chimeneas and factory-built metal novelty stoves. Must be covered when in use. </li>
            <li>Outdoor fireplaces shall be used in accordance with the manufacturer's instructions and shall be a minimum of 15 feet from any combustible structure or material. </li>
            <li>Only clean, dry seasoned wood or similar materials should be used. Many of the complaints received are a result of excessive smoke being generated due to wet or non-seasoned wood.</li>
            <li>A minimum of one portable fire extinguisher with a minimum 4-A rating or other approved on-site fire extinguishing equipment, such as dirt, sand, water barrel, or garden hose shall be available for immediate utilization.</li> 
            <li><strong>Fires shall be constantly attended until the fire is extinguished.</strong></li>
            <li>Where a fire creates or adds to a hazardous situation, the fire official is authorized to order the extinguishing of the burning operation.</li> 
            </ul>
            <h3>The use of flammable liquids to start and/or maintain a fire is prohibited!</h3>
          
        </div>
      </div>
    </div>
  );
}
